export function setElementVisible($el: HTMLElement, isVisible: boolean): void {
	isVisible ? $el.classList.remove("visibility-hidden") : $el.classList.add("visibility-hidden");
}

export function setElementDisplay($el: HTMLElement, isDisplayed: boolean): void {
	isDisplayed ? $el.classList.remove("display-none") : $el.classList.add("display-none");
}

export function findAscendingTag($el: HTMLElement, tag: string) : HTMLElement {
	while ($el.parentNode) {
		$el = $el.parentNode as HTMLElement;
		if ($el?.tagName?.toUpperCase() === tag.toUpperCase()) {
			return $el;
        }
	}
	throw new Error("Could not find parent tag");
}
